/**
 * Atlas Web bootstrap — registers the service worker (PWA offline app
 * shell) and mounts the React root inside the app providers.
 */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { AppProviders } from "./app/providers";
import { applyDocumentLocale } from "./lib/i18n";
import {
  removeLegacyToken,
  restoreSession,
  startSessionSync,
} from "./lib/auth/refresh";
import "./styles/app.css";

// PWA: register the service worker produced by vite-plugin-pwa. The
// app shell is cached offline; API data operations require connectivity
// (mutating actions are disabled while offline by the app UI).
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  void import("virtual:pwa-register").then(({ registerSW }) =>
    registerSW({ immediate: true }),
  );
}

// <html lang dir> from the device's last locale before the first paint; the
// signed-in person's own locale follows from I18nProvider.
applyDocumentLocale();

// The session (S2-05): delete the bearer token earlier builds kept in
// localStorage, start renewals and the link to other tabs, and ask the
// server (through the HttpOnly refresh cookie) whether this browser has a
// session. restoreSession() marks the session "restoring" before it
// returns, so the first render already waits for the answer.
removeLegacyToken();
startSessionSync();
void restoreSession();

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element #root not found");

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </StrictMode>,
);
